import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";
import Menu1 from "./Menu/Menu1";
import Menu2 from "./Menu/Menu2";
import Menu4 from "./Menu/Menu4";
import Menu3 from "./Menu/Menu3";
import LoadingSetData from "../../TESTPage/LoadingSetData";
import FadeIn from "react-fade-in/lib/FadeIn";
import Menu5 from "./Menu/Menu5";
import axios from "axios";
import { GetCookieToken } from "../../Cookie/GetCookie";

const SetUserData = () => {
  const baseURL = process.env.REACT_APP_API_CORS
  const token = GetCookieToken("userToken")
  const location = useLocation();
  const params = new URLSearchParams(location?.search);
  const paramName = params?.get("menuName");

  const [menu, setMenu] = useState(paramName);
  const [loading, setLoading] = useState(false);
  const [userInfo, setUserInfo] = useState([]);

  useEffect(() => {
    const getUserInfo = async () => {
      try {
        const res = await axios.get(baseURL + "/api/users/info", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setUserInfo(res?.data?.result);
      } catch (err) {
        console.error(err);
      }
    };

    setTimeout(() => {
      setLoading(true);
    }, 1000);
    getUserInfo();
  }, []);

  useEffect(() => {
    setMenu(paramName);
  }, [paramName]);

  return (
    <div className="page-content">
      {!loading ? (
        <LoadingSetData />
      ) : (
        <FadeIn>
          <Container fluid>
            <Row className="mt-1">
              <Col xxl={12}>
                {menu === "1" ? (
                  <Menu1 menu={1} userInfo={userInfo} />
                ) : menu === "2" ? (
                  <Menu3 menu={2} userInfo={userInfo} />
                ) : menu === "3" ? (
                  <Menu4 menu={3} userInfo={userInfo} />
                ) : menu === "4" ? (
                  <Menu5 menu={4} userInfo={userInfo} />
                ) 
                // : menu === "5" ? (
                //   <Menu5 menu={5} userInfo={userInfo} />
                // ) 
                : (
                  <Menu1 menu={1} />
                )}
              </Col>
            </Row>
          </Container>
        </FadeIn>
      )}
    </div>
  );
};

export default SetUserData;
